import { MagicFilled } from "@aircall/icons";
import { Box, Flex, Typography } from "@aircall/tractor";
import { useTranslation } from "react-i18next";
import { Navigate, Outlet, useLocation, useParams } from "react-router";

import { TabMenu } from "../TabMenu";

import { useBaseStore } from "@/store/store";

import { useAiLabelRule } from "@/hooks/useAiLabelRule/useAiLabelRule";
import {
  InnerLayout,
  OuterLayout,
  SectionDetailsProps,
  isAssetPageTabItem,
  isEvaluationRoute,
  shouldHideTabMenu,
  useTabs,
} from ".";

function AiLabel() {
  const { t } = useTranslation();
  const { show } = useAiLabelRule();

  if (!show) {
    return null;
  }

  return (
    <Flex
      gap="xxxs"
      alignSelf="flex-end"
      alignItems="center"
      data-test="ai-label"
      margin="s"
    >
      <Typography variant="supportingMediumS">
        {t("call_context.powered_by_aircall_ai")}
      </Typography>
      <MagicFilled size={12} />
    </Flex>
  );
}

export function SectionDetails({ mobile }: SectionDetailsProps) {
  const { pathname, search } = useLocation();

  const { callId, callType } = useParams();
  const isExpanded = useBaseStore((store) => store.isExpanded);

  const { tabs, disabledTabs } = useTabs();

  if (!isAssetPageTabItem(pathname ?? "")) {
    return <Navigate to={`/calls/${callId}/${callType}/insights${search}`} />;
  }

  const shouldHideTabs = shouldHideTabMenu(pathname);

  return (
    <OuterLayout
      // don't hide this section in mobile screen
      shrink={mobile ? false : isExpanded}
      mobile={Boolean(mobile)}
      data-test="details-section"
    >
      <InnerLayout data-test="details-section-inner">
        {!shouldHideTabs && !!tabs.length && (
          <Box p="s">
            <TabMenu tabs={tabs} disabledTabs={disabledTabs} />
          </Box>
        )}
        <Flex
          flexDirection="column"
          gap="m"
          overflow="auto"
          h="100%"
          px={isEvaluationRoute(pathname) ? "0" : "m"}
        >
          <Outlet />
        </Flex>
        <Flex flex={1} flexDirection="column-reverse">
          <AiLabel />
        </Flex>
      </InnerLayout>
    </OuterLayout>
  );
}
